/*
 * @Description: vuex-state
 * @Date: 2021-11-04 11:02:45
 * @LastEditTime: 2022-02-15 18:04:25
 */
import { LIVE_STAGE, LINE_TYPE, LAYOUT } from '@/constants/room';

export default {
  // sdkAppId
  sdkAppId: '',
  // userSig
  userSig: '',
  // 播放域名
  playerDomain: '',
  // 用户信息
  userInfo: {
    userId: '',
    userName: '',
    userAvatar: '',
  },
  // 主播用户id
  anchorUserId: '',
  // 房间号信息
  roomId: null,
  // 直播间昵称
  roomName: '',
  // 是否支持 webRTC
  isSupportWebRTC: true,
  // 直播间阶段
  liveStage: LIVE_STAGE.NOT_STARTED,
  // 线路选择-rtc|cdn|leb
  lineType: LINE_TYPE.LEB,
  // 播放状态-playing|paused
  playState: 'paused',
  // horizontal｜vertical
  layout: LAYOUT.VERTICAL,

  // 聊天室功能
  chatRoomEnable: true,
  // 能够发送信息
  sendMsgEnable: true,
  // 直播信息
  liveInfo: {},

  // 直播类型  0 视频直播， 1 图文直播
  liveType: 0,

  // 直播地址
  playUrl: '',

  // 评论数
  commentSum: 0,
  // 观看数
  viewSum: 0,

  // 直播间状态
  isActive: void(0),

  // 图文直播开启状态
  liveGraphic: false
};
